module.exports = __webpack_public_path__ + "static/zus801lp-21c3233d718f1ff9bd07964886cd5d63.png";